var _g, _g2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyCampaignHistory(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 669,
    height: 546,
    viewBox: "0 0 669 546",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "No Results",
    style: {
      mixBlendMode: "luminosity"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "circle"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 1",
    d: "M21.8496 250.682V256.354",
    stroke: "#D2D8DF",
    strokeWidth: 1.84091,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 8"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 2",
    d: "M9.11133 253.751L13.7462 258.522",
    stroke: "#D2D8DF",
    strokeWidth: 1.84091,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 4",
    d: "M3.69141 266.448H10.2451",
    stroke: "#D2D8DF",
    strokeWidth: 1.84091,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 6",
    d: "M8.57812 279.381L13.213 274.61",
    stroke: "#D2D8DF",
    strokeWidth: 1.84091,
    strokeLinecap: "round"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 9",
    d: "M21.8496 280.934V275.262",
    stroke: "#D2D8DF",
    strokeWidth: 1.84091,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 10",
    d: "M31.3029 277.151L27.5215 273.369",
    stroke: "#D2D8DF",
    strokeWidth: 1.84091,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 11",
    d: "M38.8655 267.697H33.1934",
    stroke: "#D2D8DF",
    strokeWidth: 1.84091,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 12",
    d: "M35.088 254.461L31.3066 258.242",
    stroke: "#D2D8DF",
    strokeWidth: 1.84091,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 13",
    d: "M326.256 3V6.78138",
    stroke: "#D2D8DF",
    strokeWidth: 1.84091,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 15",
    d: "M314.912 14.3438H318.694",
    stroke: "#D2D8DF",
    strokeWidth: 1.84091,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 16",
    d: "M326.256 25.6896V21.9082",
    stroke: "#D2D8DF",
    strokeWidth: 1.84091,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 17",
    d: "M335.709 14.3438H331.928",
    stroke: "#D2D8DF",
    strokeWidth: 1.84091,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 18",
    d: "M106.934 161.818V167.49",
    stroke: "#D2D8DF",
    strokeWidth: 1.84091,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 19",
    d: "M89.918 178.834H95.5901",
    stroke: "#D2D8DF",
    strokeWidth: 1.84091,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 20",
    d: "M106.934 193.957V188.285",
    stroke: "#D2D8DF",
    strokeWidth: 1.84091,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 21",
    d: "M122.057 178.834H116.385",
    stroke: "#D2D8DF",
    strokeWidth: 1.84091,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group 42"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke 22",
    d: "M513.911 367.974C518.43 367.974 522.094 371.639 522.094 376.159C522.094 380.68 518.43 384.344 513.911 384.344C509.393 384.344 505.729 380.68 505.729 376.159",
    stroke: "#D2D8DF",
    strokeWidth: 1.84091,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M551.367 293.717C556.226 292.201 563.674 286.259 565.398 279.866C566.961 285.518 573.515 292.201 579.428 292.707C572.772 295.064 566.407 302.066 565.398 307.566C564.711 301.96 555.908 294.534 551.367 293.717Z",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M52.6172 365.453C55.0474 364.695 58.7696 361.725 59.6316 358.529C60.4133 361.353 63.6894 364.695 66.646 364.949C63.3186 366.126 60.1372 369.628 59.6316 372.378C59.2881 369.575 54.8868 365.861 52.6172 365.453Z",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M97.7155 102.439C97.7155 105.946 94.8745 108.786 91.3705 108.786C87.8649 108.786 85.0254 105.946 85.0254 102.439C85.0254 98.9345 87.8649 96.0927 91.3705 96.0927C94.8745 96.0927 97.7155 98.9345 97.7155 102.439Z",
    fill: "#D1D8DF"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M521.409 119.486C521.409 125.344 516.659 130.093 510.804 130.093C504.945 130.093 500.197 125.344 500.197 119.486C500.197 113.627 504.945 108.878 510.804 108.878C516.659 108.878 521.409 113.627 521.409 119.486Z",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 34",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M668.31 90.7434C668.31 95.3915 664.544 99.158 659.899 99.158C655.252 99.158 651.486 95.3915 651.486 90.7434C651.486 86.0954 655.252 82.3288 659.899 82.3288C664.544 82.3288 668.31 86.0954 668.31 90.7434Z",
    fill: "#EBECEE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 36",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M216.298 483.739C216.298 486.669 213.924 489.044 210.995 489.044C208.067 489.044 205.693 486.669 205.693 483.739C205.693 480.809 208.067 478.434 210.995 478.434C213.924 478.434 216.298 480.809 216.298 483.739Z",
    stroke: "#D2D8DF",
    strokeWidth: 1.84091,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 38",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M213.145 61.6704C213.145 65.1769 210.304 68.0171 206.8 68.0171C203.296 68.0171 200.455 65.1769 200.455 61.6704C200.455 58.1655 203.296 55.3237 206.8 55.3237C210.304 55.3237 213.145 58.1655 213.145 61.6704Z",
    stroke: "#D2D8DF",
    strokeWidth: 1.84091,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Stroke 40",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M374.992 542.48C370.938 544.023 366.4 541.985 364.857 537.931C363.315 533.876 365.35 529.335 369.406 527.794C373.459 526.251 377.997 528.287 379.539 532.342C381.084 536.398 379.047 540.937 374.992 542.48Z",
    stroke: "#D2D8DF",
    strokeWidth: 1.84091,
    strokeLinecap: "round"
  })))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "search"
  }, /*#__PURE__*/React.createElement("g", {
    id: "documents"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 1",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M372.582 392.481H217.535C206.622 392.481 197.689 383.522 197.689 372.572V151.47C197.689 140.52 206.622 131.565 217.535 131.565H372.582C383.499 131.565 392.432 140.52 392.432 151.47V372.572C392.432 383.522 383.499 392.481 372.582 392.481Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M359.345 401.932H204.299C193.386 401.932 184.453 392.973 184.453 382.023V160.921C184.453 149.971 193.386 141.016 204.299 141.016H359.345C370.263 141.016 379.195 149.971 379.195 160.921V382.023C379.195 392.973 370.263 401.932 359.345 401.932Z",
    fill: "#E8EBF2"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.47 409.4H191.104C180.168 409.4 171.217 400.478 171.217 389.574V169.387C171.217 158.483 180.168 149.565 191.104 149.565H346.47C357.41 149.565 366.362 158.483 366.362 169.387V389.574C366.362 400.478 357.41 409.4 346.47 409.4Z",
    fill: "#D8DBEA"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M346.47 409.4H191.104C180.168 409.4 171.217 400.478 171.217 389.574V169.387C171.217 158.483 180.168 149.565 191.104 149.565H346.47C357.41 149.565 366.362 158.483 366.362 169.387V389.574C366.362 400.478 357.41 409.4 346.47 409.4Z",
    fill: "#F1F2F7"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.079 216.644H209.321C206.044 216.644 203.361 214.092 203.361 210.974C203.361 207.852 206.044 205.3 209.321 205.3H324.079C327.356 205.3 330.038 207.852 330.038 210.974C330.038 214.092 327.356 216.644 324.079 216.644Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.079 250.681H209.321C206.044 250.681 203.361 248.129 203.361 245.011C203.361 241.889 206.044 239.337 209.321 239.337H324.079C327.356 239.337 330.038 241.889 330.038 245.011C330.038 248.129 327.356 250.681 324.079 250.681Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.079 284.712H209.321C206.044 284.712 203.361 282.16 203.361 279.042C203.361 275.924 206.044 273.368 209.321 273.368H324.079C327.356 273.368 330.038 275.924 330.038 279.042C330.038 282.16 327.356 284.712 324.079 284.712Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M324.079 318.743H209.321C206.044 318.743 203.361 316.191 203.361 313.073C203.361 309.951 206.044 307.399 209.321 307.399H324.079C327.356 307.399 330.038 309.951 330.038 313.073C330.038 316.191 327.356 318.743 324.079 318.743Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M269.223 352.775H209.347C206.055 352.775 203.361 350.223 203.361 347.105C203.361 343.983 206.055 341.431 209.347 341.431H269.223C272.514 341.431 275.208 343.983 275.208 347.105C275.208 350.223 272.514 352.775 269.223 352.775Z",
    fill: "#E0E2EE"
  })), /*#__PURE__*/React.createElement("g", {
    id: "search_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Fill 21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M390.075 308.792C367.128 331.735 331.603 334.323 305.812 316.61C302.516 314.306 299.379 311.717 296.454 308.792C294.948 307.291 293.528 305.742 292.191 304.111C289.515 300.854 287.172 297.381 285.252 293.792C281.87 287.73 279.57 281.298 278.314 274.65C274.262 253.8 280.32 231.357 296.454 215.231C312.626 199.057 335.072 193.039 355.926 197.051C362.571 198.345 369.009 200.645 375.072 203.988C378.666 205.951 382.092 208.294 385.354 210.969C386.981 212.302 388.53 213.726 390.031 215.231C392.962 218.156 395.589 221.288 397.85 224.588C415.572 250.37 412.978 285.893 390.075 308.792Z",
    fill: "white",
    fillOpacity: 0.1
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M383.648 304.269C359.775 328.147 321.087 328.142 297.209 304.269C273.363 280.423 273.363 241.73 297.24 217.857C321.087 194.011 359.775 194.011 383.621 217.857C407.495 241.73 407.495 280.423 383.648 304.269ZM395.902 205.593C365.259 174.95 315.602 174.95 284.959 205.593C254.32 236.232 254.294 285.919 284.933 316.562C312.822 344.442 356.534 346.957 387.28 324.066C390.283 321.827 393.175 319.317 395.933 316.562C398.687 313.804 401.197 310.912 403.432 307.909C426.323 277.159 423.787 233.478 395.902 205.593Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M516.499 432.072L515.213 433.359C506.701 441.874 492.764 441.874 484.249 433.359L405.662 354.772L437.912 322.522L516.499 401.109C525.015 409.624 525.015 423.557 516.499 432.072Z",
    fill: "url(#paint0_linear_205_7715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 27",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M405.129 305.507L428.351 328.729L411.865 345.211L388.646 321.989C391.711 319.704 394.657 317.143 397.477 314.332C400.287 311.522 402.848 308.571 405.129 305.507Z",
    fill: "#E0E2EE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M515.324 400.143L483.279 432.184L477.51 426.41L509.55 394.37L515.324 400.143Z",
    fill: "#EF545F"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M439.691 323.634L406.768 356.557L401.877 351.666L434.8 318.743L439.691 323.634Z",
    fill: "url(#paint1_linear_205_7715)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 33",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M367.847 209.644L287.108 290.379C284.067 284.929 282 279.147 280.875 273.17L350.637 203.407C356.61 204.575 362.397 206.638 367.847 209.644Z",
    fill: "white",
    fillOpacity: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill 35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M394.319 228.835L307.03 311.178C303.904 309.12 300.929 306.804 298.154 304.187C296.726 302.839 295.375 301.457 294.111 299.998L382.463 216.643C384.01 217.84 385.479 219.115 386.903 220.462C389.678 223.079 392.174 225.882 394.319 228.835Z",
    fill: "white",
    fillOpacity: 0.5
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_205_7715",
    x1: 464.274,
    y1: 263.911,
    x2: 347.051,
    y2: 381.134,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF8960"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF62A5"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_205_7715",
    x1: 420.784,
    y1: 299.836,
    x2: 382.97,
    y2: 337.65,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FF404E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FF62A5"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyCampaignHistory);
export default __webpack_public_path__ + "static/media/empty-campaign-history.d754719690ac61491266724ecfe06b0a.svg";
export { ForwardRef as ReactComponent };